import React from 'react';
import { MyMLabel } from '../ui-elements/MyMLabel';

export const KeywordLabel = (props) => {
  const {
    keyword,
    value,
    fontSize,
    isEllipsis,
    // 2024.12.23 MyMine Version2.1対応 Add Start
    multiline,
    isDangerouslySetInnerHTML
    // 2024.12.23 MyMine Version2.1対応 Add End
  } = props;

  /* keywordを半角変換 */
  const halfKeyWord = keyword.trim()
    .replace(/[！-～]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
    .replace(/　/g, ' ')
    .replace(/[ァ-ン]/g, function (s) {
      const fullWidthKatakana = "。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン";
      const halfWidthKatakana = "｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ";
      return halfWidthKatakana[fullWidthKatakana.indexOf(s)];
    })
    .toLowerCase();

  /* keywordを全角変換 */
  const fullKeyWord = keyword.replace(/[！-～]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  }).replace(/　/g, ' ')
    .replace(/[｡-ﾝ]/g, function (s) {
      const halfWidthKatakana = "｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ";
      const fullWidthKatakana = "。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワンヴヽ";
      return fullWidthKatakana[halfWidthKatakana.indexOf(s)];
    })
    .toLowerCase();

  /* 元々のキーワード + 半角変換したキーワード */
  const searchKeyWord = `${keyword.trim().replace(/　/g, ' ').toLowerCase()} ${halfKeyWord} ${fullKeyWord}`;

  /* キーワードを正規表現へ */
  const regKeyWord = new RegExp(searchKeyWord.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&').replace(/ +/g, ' ').replace(/ /g, '|'), 'gi');

  /* valueを半角変換 */
  var halfValue = value.replace(/[！-～]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  }).replace(/　/g, ' ').toLowerCase();

  // キーワード未指定 Or 対象キーワードに合致しない場合はそのまま
  if (keyword.trim() === '' || halfValue.search(regKeyWord) === -1) {
    // 2024.12.23 MyMine Version2.1対応 Modify Start
    if (isDangerouslySetInnerHTML) {
      return (
        <MyMLabel
          component='span'
          fontSize={fontSize}
          dangerouslySetInnerHTML={{ __html: value }}
        >
        </MyMLabel>
      );
    } else {
      return (
        // 2024.5.8 MyMine Version1.5対応 Modify Start
        <span style={{ fontSize: fontSize }}> {value}</span >
        // 2024.5.8 MyMine Version1.5対応 Modify End
      );
    }
    // 2024.12.23 MyMine Version2.1対応 Modify End
  }

  // キーワードに一致した場合
  // 半角スペースで区切る
  const keywords = searchKeyWord.split(/ /);
  // キーワードが一致する順に並び替え
  keywords.sort((x, y) => {
    if (x.length > y.length) return -1;
    if (x.length < y.length) return 1;
    return value.toLowerCase().indexOf(x) - value.toLowerCase().indexOf(y);
  });

  // 色変えのためにvalueを区切る
  var outputArray = [];
  var keywordMatchIndex;
  var word = value;
  var halfWord = halfValue;
  var compKeywords = [];
  var regSearch;

  for (var index in keywords) {
    // キーワードを正規表現へ
    regSearch = new RegExp(keywords[index].replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'), 'gi');
    // 1つ目のキーワード
    if (outputArray.length === 0) {
      // キーワードに一致しない場合は次のキーワードへ
      while (halfWord.toLowerCase().search(regSearch) !== -1 && keywords[index] !== '') {
        // キーワード一致位置
        keywordMatchIndex = halfWord.toLowerCase().search(regSearch);
        // キーワード一致以前の文字をpush
        if (keywordMatchIndex !== 0) {
          outputArray.push(word.substr(0, keywordMatchIndex));
        }
        // キーワード一致文字以降の残りが省略文字の場合、処理を抜ける
        if (word.substr(keywordMatchIndex) === '...') {
          word = word.substr(keywordMatchIndex);
          halfWord = halfWord.substr(keywordMatchIndex);
          break;
        }
        // キーワード一致文字をpush
        outputArray.push(word.substr(halfWord.toLowerCase().search(regSearch), keywords[index].length));
        // キーワード一致以降の文字をセット
        word = word.substr(keywordMatchIndex + keywords[index].length);
        halfWord = halfWord.substr(keywordMatchIndex + keywords[index].length);
      }

      if (word != null) {
        // キーワード一致以降の文字が残っていたらpush
        outputArray.push(word);
        // チェックが終わったキーワードをセット
        compKeywords.push(keywords[index]);
      }
    } else {
      // 2つ目以降のキーワード
      var wArray = [];
      for (var arryIndex in outputArray) {
        word = outputArray[arryIndex];
        halfWord = outputArray[arryIndex].replace(/[！-～]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 0xFEE0); }).replace(/　/g, ' ').toLowerCase();
        // 既に振り分けが済んでいる場合は次へ
        if (halfWord.toLowerCase().search(new RegExp(compKeywords.join(' ').replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&').replace(/ +/g, ' ').replace(/ /g, '|'), 'gi')) > -1) {
          wArray.push(word);
          word = word.substr(keywordMatchIndex);
          halfWord = halfWord.substr(keywordMatchIndex);
        } else {
          // キーワードに一致しない場合は次のキーワードへ
          while (halfWord.toLowerCase().search(regSearch) !== -1 && keywords[index] !== '') {
            // キーワード一致位置
            keywordMatchIndex = halfWord.toLowerCase().search(regSearch);
            // キーワード一致以前の文字をpush
            if (keywordMatchIndex !== 0) {
              wArray.push(word.substr(0, keywordMatchIndex));
            }
            // キーワード一致文字以降の残りが省略文字の場合、処理を抜ける
            if (outputArray.length - 1 === Number(arryIndex) && word.substr(keywordMatchIndex) === '...') {
              word = word.substr(keywordMatchIndex);
              halfWord = halfWord.substr(keywordMatchIndex);
              break;
            }
            // キーワード一致文字をpush
            wArray.push(word.substr(halfWord.toLowerCase().search(regSearch), keywords[index].length));
            // キーワード一致以降の文字をセット
            word = word.substr(keywordMatchIndex + keywords[index].length);
            halfWord = halfWord.substr(keywordMatchIndex + keywords[index].length);
          }
          if (word != null) {
            // キーワード一致以降の文字が残っていたらpush
            wArray.push(word);
            word = '';
          }
        }
      }
      // チェックが終わったキーワードをセット
      compKeywords.push(keywords[index]);
      // outputArrayを更新
      outputArray = wArray;
    }
  }

  // 2024.12.23 MyMine Version2.1対応 Modify Start
  return isDangerouslySetInnerHTML
    ? <MyMLabel
      component='span'
      fontSize={fontSize}
      className={multiline ? '' : 'text-nowrap'}
      dangerouslySetInnerHTML={{ __html: outputArray.join('') }}
    >
    </MyMLabel>
    : <MyMLabel
      component='span'
      className={multiline ? '' : 'text-nowrap'}
      fontSize={fontSize}
    >
      {!isDangerouslySetInnerHTML &&
        outputArray.map((value, i) => {
          // キーワードにマッチしたものは赤色にする(省略記号は除く)
          const isMatchKeyword = (value.replace(/[！-～]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 0xFEE0); }).replace(/　/g, ' ').search(regKeyWord) > -1 && outputArray.length - 1 !== i && (value !== '...' || (value === '...' && isEllipsis === false)));
          return <React.Fragment key={i}>{isMatchKeyword ? <em style={{ color: 'red', fontStyle: 'normal' }}>{value}</em> : <>{value}</>}</React.Fragment>
        })}
    </MyMLabel>

  // 2024.12.23 MyMine Version2.1対応 Modify End
}